import { Heading, useMediaQuery } from '@chakra-ui/react';

const MobileFooter = ({stateProps}) => {

  const isMobile = useMediaQuery('(max-width: 768px)',{ssr:false})
  if (isMobile[0] === true) {
    return (
      <Heading variant='footer'>
        Copyright {stateProps.currentYear} | Resume Scripter, LLC. Portland, Oregon
      </Heading>
    );
  } else {
    return null;
  }
};
export default MobileFooter;
